import {
  ROOT,
  BOOKING_GET_ALL,
  BOOKING_EXPORT,
  BOOKING_DETAIL,
  BOOKING_CANCEL,
  BOOKING_TRANSACTION,
  BOOKING_TRANSACTION_UPDATE,
  BOOKING_TRANSACTION_EXPORT,
  REQUEST_GET_ALL,
  REQUEST_FEEDBACK,
  REQUEST_DETAIL,
  REQUEST_EXPORT,
  BOOKING_GETA_ALL_MOBILE,
  RE_SYNC,
  BOOKING_UNMAP_GET_ALL,
  BOOKING_UNMAP_DETAIL,
  BOOKING_EXPORT_UNMAP,
  RE_SYNC_UNMAP,
  RE_SYNCS,
  CREATE_TOKEN_EZPAY
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function createTokenEzpay() {
  return fetch(ROOT + CREATE_TOKEN_EZPAY, requestOptions.get())
    .then(handleResponse);
}

function getAllBooking(params) {
  return fetch(ROOT + BOOKING_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function getAllBookingUnmap(params) {
  return fetch(ROOT + BOOKING_UNMAP_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function getBookingDetailUnmap(code) {
  return fetch(ROOT + BOOKING_UNMAP_DETAIL + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getAllBookingMobile(params) {
  return fetch(ROOT + BOOKING_GETA_ALL_MOBILE, requestOptions.post(params))
    .then(handleResponse);
}
// function exportBooking(params) {
//   return fetch(ROOT + BOOKING_EXPORT, requestOptions.post(params))
//     .then(handleResponse);
// }

function exportBooking(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + BOOKING_EXPORT, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function exportBookingUnmap(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + BOOKING_EXPORT_UNMAP, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function exportRequest(params) {
  return fetch(ROOT + REQUEST_EXPORT, requestOptions.post(params))
    .then(handleResponse);
}

function getBookingDetail(code) {
  return fetch(ROOT + BOOKING_DETAIL + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getRequestDetail(code) {
  return fetch(ROOT + REQUEST_DETAIL + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function cancelBooking(data) {
  return fetch(ROOT + BOOKING_CANCEL, requestOptions.post(data))
    .then(handleResponse);
}

function getAllRequestBooking(params) {
  return fetch(ROOT + REQUEST_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function feedbackRequest(params) {
  return fetch(ROOT + REQUEST_FEEDBACK, requestOptions.post(params))
    .then(handleResponse);
}

function getRequestBookingDetail(code) {
  return fetch(ROOT + BOOKING_DETAIL + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function getAllTransaction(params) {
  return fetch(ROOT + BOOKING_TRANSACTION, requestOptions.post(params))
    .then(handleResponse);
}

function updateTransaction(data) {
  return fetch(ROOT + BOOKING_TRANSACTION_UPDATE, requestOptions.post(data))
    .then(handleResponse);
}

function exportTransaction(data) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + BOOKING_TRANSACTION_EXPORT, requestOptions.post(data))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function reSync(data) {
  return fetch(ROOT + RE_SYNC, requestOptions.post(data))
    .then(handleResponse);
}

function reSyncs(data) {
  return fetch(ROOT + RE_SYNCS, requestOptions.post(data))
    .then(handleResponse);
}

function reSyncUnmap(data) {
  return fetch(ROOT + RE_SYNC_UNMAP, requestOptions.post(data))
    .then(handleResponse);
}

export const service = {
  createTokenEzpay,
  getAllBooking,
  exportBooking,
  getBookingDetail,
  cancelBooking,
  getAllRequestBooking,
  getRequestBookingDetail,
  getAllTransaction,
  updateTransaction,
  exportTransaction,
  feedbackRequest,
  getRequestDetail,
  exportRequest,
  getAllBookingMobile,
  reSync,
  getBookingDetailUnmap,
  getAllBookingUnmap,
  exportBookingUnmap,
  reSyncUnmap,
  reSyncs
};